import uniq from 'lodash/uniq';
import { createSelector, } from 'reselect';
import { productsInitialState, } from './reducers';

export const handleFilters = (state: any, action: any) => {
    if (!action.payload) {
        return {
            ...productsInitialState.filters,
        };
    }

    const { page, limit, ...advancedFilters } = action.payload;
    const {
        limit: prevLimit,
        page: prevPage,
        ...prevFilters
    } = state.filters;

    const basicFilters = {
        page: Number(page) || state.filters.page,
        limit: Number(limit) || state.filters.limit,
    };

    const preparedAdvancedFilters = Object
        .entries(advancedFilters)
        .reduce((filters, [ filterKey, filterValue ]) => {
            const specificFilter = prevFilters[filterKey as keyof typeof prevFilters];

            if (!specificFilter) return prevFilters;

            if (Array.isArray(filterValue)) {
                return {
                    ...filters,
                    [filterKey]: uniq([ ...specificFilter, ...filterValue, ]),
                };
            }

            const found = specificFilter.indexOf(filterValue);

            if (found > -1) {
                return {
                    ...filters,
                    [filterKey]: [ ...specificFilter.slice(0, found), ...specificFilter.slice(found + 1) ],
                };
            }

            return {
                ...filters,
                [filterKey]: uniq([ ...specificFilter, filterValue, ]),
            };
        }, prevFilters);

    return {
        ...basicFilters,
        ...preparedAdvancedFilters,
    };
};

type MappingType = {
    collection: {
        filters: {
            page: number,
            limit: number,
            primarySchool: Array<string>,
            bookSeries: Array<string>,
            schoolSubjects: Array<string>,
            highSchool: Array<string>,
            gymnasium: Array<string>,
        },
    },
};

const getFilters = (products: MappingType) => {
    const { page, limit, ...filters } = products.collection.filters;

    return {
        basic: { page, limit, },
        advanced: filters,
    };
};

const checkEveryFilterArrayIsNotEmpty = (filter: Array<string>) => filter.length;

export const isAnySelectedSelector = createSelector(
    [ getFilters, ],
    ({ advanced, }) => Object
        .values(advanced)
        .some(checkEveryFilterArrayIsNotEmpty),
);
